<template>
  <div class="being-matched">
    <div class="header">
      <div class="left">
        今日剩餘 <span class="times">{{ AnonymousCallProvider.times }}</span> 次
      </div>
      <SettingVue></SettingVue>
    </div>
    <div class="content no-scrollbar">
      <button class="btn-call" type="button" @click="cancel()">
        <img class="icon-call" src="./images/icon-call.png" alt="" />
        <span>Calling...</span>
      </button>
      <div class="description">
        看看哪位陪玩會先接通～<br />
        (撥打時為匿名，可選擇是否公開身份)
      </div>
      <!-- <button class="btn-cancel" type="button" @click="cancel()">
        取消
      </button> -->
    </div>
  </div>
</template>
<script>
import SettingVue from './setting.vue';
import AnonymousCallProvider from './anonymousCall';
export default {
  name: 'BeingMatched',
  components: {
    SettingVue
  },
  data() {
    return { AnonymousCallProvider };
  },
  watch: {},
  computed: {},
  methods: {
    cancel() {
      this.$emit('onCancel');
    },
    getDetail() {
      setInterval(() => {
        this.$emit('refresh');
      }, 3000);
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.being-matched {
  color: white;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  line-height: 1.5;
  position: relative;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-bottom: 80px;
    margin-top: 20px;
    flex: none;
    position: relative;
    width: 100%;
    padding: 0 24px;
  }
  .left {
    color: rgba(255, 255, 255, 0.55);
    .times {
      color: #ffffff;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: auto;
    height: 1px;
    overflow: auto;
  }
  .title {
    color: #ffffff;
    font-size: 33px;
    font-weight: 500;
    margin-bottom: 67px;
  }
  .sex-image {
    width: auto;
    height: 200px;
    position: relative;
    object-fit: cover;
    margin-bottom: 158px;
  }
  .btn-cancel {
    border-radius: 1197.19px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.35);
    border-width: 2.4px;
    // width: 104.26px;
    padding: 8px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.77);
  }
  .btn-call {
    // background: rgba(25, 203, 28, 0.35);
    border-color: rgba(255, 255, 255, 0.35);
    border-width: 2.4px;
    border-radius: 1197.19px;
    border-style: solid;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 22px;
    padding: 12px 50px 12px 30px;
    // color: white;
    color: rgba(255, 255, 255, 0.77);
    flex: none;
    &.active {
      background: #19cb1c;
    }
    img {
      margin-right: 20px;
      width: 20px;
    }
  }
  .description {
    color: rgba(255, 255, 255, 0.55);
    text-align: center;
    font-weight: 400;
    line-height: 1.6;
    margin-bottom: 38px;
  }
}
</style>
